<template>
    <!-- Authors Table Card -->
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
                    <a-form-item label="标题">
                        <a-input v-model="dataForm.title" placeholder="标题" allowClear />
                    </a-form-item>
                    <a-form-item label="是否可用">
                        <a-select v-model="dataForm.status" placeholder="请选择" style="width: 200px" allowClear>
                            <a-select-option value="1">是</a-select-option>
                            <a-select-option value="2">否</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
                    </a-form-item>
                    <a-form-item v-permission="['admin:kefu:create']">
                        <a-button type="primary" @click="addOrUpdateHandle()">新增客服微信</a-button>
                    </a-form-item>
                </a-form>

                <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="id"
                    :loading="dataListLoading" :scroll="{ x: 1500 }">
                    <template slot="mid_img" slot-scope="mid_img">
                        <img v-if="mid_img" :src="mid_img" alt="" width="50px" height="50px"
                            style="cursor: pointer;object-fit: cover;" @click="preview(mid_img)" />
                        <a-tag v-else>未上传</a-tag>
                    </template>
                    <template slot="kefu_img" slot-scope="kefu_img">
                        <img v-if="kefu_img" :src="kefu_img" alt="" width="50px" height="50px"
                            style="cursor: pointer;object-fit: cover;" @click="preview(kefu_img)" />
                        <a-tag v-else>未上传</a-tag>
                    </template>
                    <template slot="link_logo" slot-scope="link_logo">
                        <img v-if="link_logo" :src="link_logo" alt="" width="50px" height="50px"
                            style="cursor: pointer;object-fit: cover;" @click="preview(link_logo)" />
                        <a-tag v-else>未上传</a-tag>
                    </template>
                    <template slot="status" slot-scope="status">
                        <a-tag :color="status === '1' ? 'green' : 'red'">
                            {{ status === '1' ? '可用' : '不可用' }}
                        </a-tag>
                    </template>
                    <template slot="dec" slot-scope="dec">
                        <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                            {{ dec }}
                        </div>
                    </template>
                    <template slot="link_url" slot-scope="link_url">
                        <span  target="_blank" style="color: #1890ff;text-decoration: underline;">{{ link_url }}</span>
                    </template>
                    <template slot="editBtn" slot-scope="text, row">
                        <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.id)"
                            v-permission="['admin:kefu:update']">
                            编辑
                        </a-button>
                        <a-button type="link" class="btn-edit" @click="deleteHandle(row.id)"
                            v-permission="['admin:kefu:delete']">
                            删除
                        </a-button>
                    </template>
                </a-table>
            </a-col>
            <!-- / Authors Table Column -->
        </a-row>

        <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
    </a-card>
    <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
    mixins: [viewModule],
    components: {
        addorupdate,
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/admin/kefu/page",
                deleteURL: "/admin/kefu/delete",
            },
            dataForm: {
                title: "",
                status: undefined,
            },
            columns: [
                {
                    title: "标题",
                    dataIndex: "title",
                    width: 150,
                    ellipsis: true,
                },
                {
                    title: "描述",
                    dataIndex: "dec",
                    scopedSlots: { customRender: "dec" },
                    width: 100,
                },
                {
                    title: "客户访问链接",
                    dataIndex: "link_url",
                    width: 200,
                    scopedSlots: { customRender: "link_url" },
                },
                {
                    title: "分享logo",
                    dataIndex: "link_logo",
                    scopedSlots: { customRender: "link_logo" },
                    width: 150,
                },
                {
                    title: "中转页面图片",
                    dataIndex: "mid_img",
                    scopedSlots: { customRender: "mid_img" },
                    width: 150,
                },
                {
                    title: "客服图片",
                    dataIndex: "kefu_img",
                    scopedSlots: { customRender: "kefu_img" },
                    width: 150,
                },
                {
                    title: "是否可用",
                    dataIndex: "status",
                    scopedSlots: { customRender: "status" },
                    width: 100,
                },
                {
                    title: "小程序页面标题",
                    dataIndex: "mini_title",
                    width: 200,
                    ellipsis: true,
                },
                {
                    title: "小程序页面底部提示",
                    dataIndex: "mini_msg",
                    width: 200,
                    ellipsis: true,
                },
                {
                    title: "",
                    scopedSlots: { customRender: "editBtn" },
                    width: 300,
                    fixed: "right",
                },
            ],
        };
    },
    methods: {
        preview(url) {
            this.$viewerApi({
                images: [url],
            });
        },
    },
};
</script>
